import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface ShadowPickerProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
}

const SHADOWS = [
  { level: 0, get label() { return translateInterfaceText("Nenhuma"); }, preview: 'none' },
  { level: 1, get label() { return translateInterfaceText("Leve"); }, preview: '0 1px 2px rgba(0, 0, 0, 0.05)' },
  { level: 2, get label() { return translateInterfaceText("Média"); }, preview: '0 4px 6px rgba(0, 0, 0, 0.1)' },
  { level: 3, get label() { return translateInterfaceText("Forte"); }, preview: '0 10px 15px rgba(0, 0, 0, 0.15)' },
];

export function ShadowPicker({ value, onChange, label = 'Sombra' }: ShadowPickerProps) {
  useLanguage();
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">{label}</Label>
      <div className="grid grid-cols-4 gap-2">
        {SHADOWS.map((shadow) => (
          <button
            key={shadow.level}
            type="button"
            onClick={() => onChange(shadow.level)}
            className={cn(
              'flex flex-col items-center gap-2 p-3 rounded-lg border-2 transition-all hover:border-primary/50',
              value === shadow.level
                ? 'border-primary bg-primary/5'
                : 'border-border bg-background'
            )}
          >
            <div
              className="w-12 h-12 bg-white rounded"
              style={{ boxShadow: shadow.preview }}
            />
            <span className="text-xs font-medium">{shadow.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
